import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import ContentBlock from '../_components/ContentBlock'

const useStyles = makeStyles<Theme, ChipsToDoorProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'ChipsToDoor' }
)

export interface ChipsToDoorProps {
  classes?: StyleClasses<typeof useStyles>
}

function ChipsToDoor(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentBlock
        img={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/color-to-go-on-ladder.png'}
        preTitle="GET FREE PAINT CHIPS DELIVERED"
        title="Right to Your Door!"
        description={
          <>
            See how your top color picks compare. Get a
            <br />
            feel for how they’ll look in your space using
            <br />
            color chips.
          </>
        }
        linkHref="https://samples.sherwin-williams.com/?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=samples-color-chips"
        linkLabel="Order Free Chips"
      />
    </div>
  )
}

export default ChipsToDoor
